import { render, staticRenderFns } from "./FichaTecnicaTarefaPage.vue?vue&type=template&id=9a852ac6&scoped=true"
import script from "./FichaTecnicaTarefaPage.vue?vue&type=script&lang=js"
export * from "./FichaTecnicaTarefaPage.vue?vue&type=script&lang=js"
import style0 from "./FichaTecnicaTarefaPage.vue?vue&type=style&index=0&id=9a852ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a852ac6",
  null
  
)

export default component.exports